import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet",
  "use": "icon-sheet-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet\"><g transform=\"translate(3 2)\" stroke-width=\"1.5\" fill=\"transparent\" stroke=\"currentColor\"><rect x=\".75\" y=\".75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M5 7h8m-8 6h8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol